import React from 'react'

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton
} from "../JobBoardDetails.styles";

interface DeleteJobConfirmation {
    onDelete: () => any
    onCancel: () => any
    hardDelete?: boolean
}

const DeleteJobConfirmation = ({
    onDelete,
    onCancel,
    hardDelete,
}: DeleteJobConfirmation) => {
    return (
        <PopupContainer>
            <PopupTitle>Delete Job Post</PopupTitle>
            <PopupDescription>
                {hardDelete
                    ? `You can't undo this action and any applicants will be removed`
                    : `Are you sure you would like to delete
				the posting?`}
            </PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onCancel}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    Cancel
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onDelete}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    Delete
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    )
}

export default DeleteJobConfirmation;
